const provinceReducer = (state = "", action) => {
    let { type, province } = action;
    switch (type) {
        case "ADD_PROVINCE":
            return province;
        default:
            return state;
    }
};

export default provinceReducer;
